export const MoreInfoUat = {
    closeButton: 'moreInfo.closeButton'
}